import axios from 'axios';

export async function syncGroups(crm, ids) {
  const {data} = await axios.post(`/api/?entity=groups&action=crmSyncGroups&crm=${crm}`, {groups: ids});
  return data;
}
